"use client";

import { c as _c } from "react/compiler-runtime";
import { ApiIdentity } from "@/generated/models/ApiIdentity";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useCallback, useEffect, useState } from "react";
import UserPageStatsActivityDistributions from "./distributions/UserPageStatsActivityDistributions";
import UserPageActivityTabs from "./tabs/UserPageActivityTabs";
import UserPageStatsActivityTDHHistory from "./tdh-history/UserPageStatsActivityTDHHistory";
import UserPageStatsActivityWallet from "./wallet/UserPageStatsActivityWallet";
export enum USER_PAGE_ACTIVITY_TAB {
  WALLET_ACTIVITY = "WALLET_ACTIVITY",
  DISTRIBUTIONS = "DISTRIBUTIONS",
  TDH_HISTORY = "TDH_HISTORY",
}
const SEARCH_PARAM_ACTIVITY = "activity";
export const WALLET_ACTIVITY_FILTER_PARAM = "wallet-activity";
export const WALLET_ACTIVITY_PAGE_PARAM = "page";
export const WALLET_DISTRIBUTION_PAGE_PARAM = "page";
const ENUM_AND_PATH: {
  type: USER_PAGE_ACTIVITY_TAB;
  path: string;
}[] = [{
  type: USER_PAGE_ACTIVITY_TAB.WALLET_ACTIVITY,
  path: "wallet-activity"
}, {
  type: USER_PAGE_ACTIVITY_TAB.DISTRIBUTIONS,
  path: "distributions"
}, {
  type: USER_PAGE_ACTIVITY_TAB.TDH_HISTORY,
  path: "tdh-history"
}];
export default function UserPageActivityWrapper(t0) {
  const $ = _c(30);
  const {
    profile,
    activeAddress
  } = t0;
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams?.get(SEARCH_PARAM_ACTIVITY);
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const activity = t1;
  const enumToPath = _temp;
  const pathToEnum = _temp2;
  const [activeTab, setActiveTab] = useState(USER_PAGE_ACTIVITY_TAB.WALLET_ACTIVITY);
  let t2;
  let t3;
  if ($[2] !== activity) {
    t2 = () => {
      setActiveTab(pathToEnum(activity ?? ""));
    };
    t3 = [activity];
    $[2] = activity;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== searchParams) {
    t4 = (name, value) => {
      const params = new URLSearchParams(searchParams?.toString() ?? "");
      params.set(name, enumToPath(value));
      params.delete(WALLET_ACTIVITY_FILTER_PARAM);
      params.delete(WALLET_ACTIVITY_PAGE_PARAM);
      params.delete(WALLET_DISTRIBUTION_PAGE_PARAM);
      return params.toString();
    };
    $[5] = searchParams;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const createQueryString = t4;
  let t5;
  if ($[7] !== createQueryString || $[8] !== pathname || $[9] !== router) {
    t5 = tab => {
      router.replace(`${pathname}?${createQueryString(SEARCH_PARAM_ACTIVITY, tab)}`, {
        scroll: false
      });
    };
    $[7] = createQueryString;
    $[8] = pathname;
    $[9] = router;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const onActiveTab = t5;
  let t6;
  if ($[11] !== activeTab || $[12] !== onActiveTab) {
    t6 = <UserPageActivityTabs activeTab={activeTab} setActiveTab={onActiveTab} />;
    $[11] = activeTab;
    $[12] = onActiveTab;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== activeAddress || $[15] !== activeTab || $[16] !== profile) {
    t7 = activeTab === USER_PAGE_ACTIVITY_TAB.WALLET_ACTIVITY && <UserPageStatsActivityWallet profile={profile} activeAddress={activeAddress} />;
    $[14] = activeAddress;
    $[15] = activeTab;
    $[16] = profile;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== activeAddress || $[19] !== activeTab || $[20] !== profile) {
    t8 = activeTab === USER_PAGE_ACTIVITY_TAB.DISTRIBUTIONS && <UserPageStatsActivityDistributions profile={profile} activeAddress={activeAddress} />;
    $[18] = activeAddress;
    $[19] = activeTab;
    $[20] = profile;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== activeTab || $[23] !== profile) {
    t9 = activeTab === USER_PAGE_ACTIVITY_TAB.TDH_HISTORY && <UserPageStatsActivityTDHHistory profile={profile} />;
    $[22] = activeTab;
    $[23] = profile;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t6 || $[26] !== t7 || $[27] !== t8 || $[28] !== t9) {
    t10 = <div className="tw-mt-7 lg:tw-mt-9">{t6}{t7}{t8}{t9}</div>;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  return t10;
}
function _temp2(path) {
  const found_0 = ENUM_AND_PATH.find(e_0 => e_0.path === path);
  return found_0?.type ?? USER_PAGE_ACTIVITY_TAB.WALLET_ACTIVITY;
}
function _temp(type) {
  const found = ENUM_AND_PATH.find(e => e.type === type);
  return found?.path ?? "";
}